import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User } from 'lucide-react';

interface BlogCardProps {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  author: string;
  imageUrl: string;
  className?: string;
}

const BlogCard: React.FC<BlogCardProps> = ({
  id,
  title,
  excerpt,
  category,
  date,
  author,
  imageUrl,
  className = '',
}) => {
  return (
    <div className={`group rounded-xl shadow-lg overflow-hidden bg-white hover:shadow-xl transition-all duration-300 ${className}`}>
      <div className="relative overflow-hidden aspect-video">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute top-4 left-4">
          <span className="inline-block px-3 py-1 rounded-full bg-blue-600 text-white text-xs font-medium">
            {category}
          </span>
        </div>
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
          <Link to={`/blog/${id}`}>{title}</Link>
        </h3>
        
        <p className="text-gray-600 mb-4">
          {excerpt.length > 120 ? `${excerpt.substring(0, 120)}...` : excerpt}
        </p>
        
        <div className="flex items-center text-sm text-gray-500">
          <div className="flex items-center mr-4">
            <Calendar size={16} className="mr-1" />
            <span>{date}</span>
          </div>
          <div className="flex items-center">
            <User size={16} className="mr-1" />
            <span>{author}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;